import React, { useEffect, useRef, useState } from 'react';
// import { List } from 'antd';
import { connect } from 'umi';
import InfiniteScroll from 'react-infinite-scroll-component';
import { get } from 'lodash';
import { Text, ListItem } from '@digitalc/dxp-ui';
import { BaseSpin } from '@/components';
import { CardItem } from '@/pages/PointShop/Order/components';
import useResponsive from '@/hooks/useResponsive';
import useGCPI18n from '@/hooks/useGCPI18n';
import { getThemeImgByKey } from '@/utils/utils';
import Header from '../Header';
import styles from './index.less';

// import noDataImg from '@/assets/images/point/point_no_Data.png';
import noDataImgGlobe from '@/assets/images/point/point_no_Data_globe.png';

const DEFAULT_PAGE_SIZE = 10;

const Order = props => {
  // 响应式 hook
  useResponsive();
  const GCPI18n = useGCPI18n();

  const [dataOfferList, setdataOfferList] = useState([]); // orderList
  const [pageIndex, setPageIndex] = useState(1);
  const pageRef = useRef(null);

  const {
    getPointOrderListDXP,
    pointOrderListTotal,
    pointOrderParams,
    loading = false,
    dxpToken,
    isMulPoints,
  } = props;

  /**
   * Fetch order list from API
   * @param {number} page - Page index to fetch
   * @param {boolean} append - Whether to append to existing list or replace
   */
  const fetchOrderList = async (page, append = false) => {
    const payload = {
      ...pointOrderParams,
      order: 'DESC',
      pageSize: DEFAULT_PAGE_SIZE,
      pageIndex: page,
    };

    try {
      const res = await getPointOrderListDXP(payload);
      const { code } = res;
      if (code === '200') {
        const orderList = get(res, 'data.orderList') || [];
        if (append) {
          if (orderList.length > 0) {
            setdataOfferList(val => [...val, ...orderList]);
          }
        } else {
          setdataOfferList(orderList);
        }
        setPageIndex(get(res, 'data.pageInfo.pageIndex') || page);
      } else if (!append) {
        setdataOfferList([]);
      }
    } catch (error) {
      if (!append) {
        setdataOfferList([]);
      }
    }
  };

  useEffect(() => {
    fetchOrderList(1, false);
  }, []);

  const loadMoreData = async () => {
    const nextPageIndex = pageIndex + 1;
    fetchOrderList(nextPageIndex, true);
  };

  return (
    <div className={styles.orderWrap}>
      <Header
        title={GCPI18n({
          id: 'lb_header_redemption_order',
        })}
      />

      <div ref={pageRef} id="scrollableDiv" className={styles.scrollableDiv}>
        {pageRef.current && (
          <InfiniteScroll
            dataLength={dataOfferList.length}
            next={loadMoreData}
            hasMore={dataOfferList.length < pointOrderListTotal}
            scrollableTarget={pageRef.current}
          >
            <BaseSpin spinning={loading}>
              {dataOfferList && dataOfferList.length > 0 ? (
                // <List>
                //   {dataOfferList.map(item => (
                //     <List.Item key={item.orderNbr}>
                //       <CardItem data={item} />
                //     </List.Item>
                //   ))}
                // </List>
                <div className={styles.listWrap}>
                  {dataOfferList.map(item => (
                    <ListItem listType="ListItemCustom" key={item.orderNbr}>
                      <CardItem data={item} dxpToken={dxpToken} isMulPoints={isMulPoints} />
                    </ListItem>
                  ))}
                </div>
              ) : (
                <>
                  {!loading && (
                    <div className={styles.searchEmpty}>
                      <img src={getThemeImgByKey('orderEmpty') || noDataImgGlobe} alt="" />
                      <Text
                        style={{ marginBottom: '0.08rem', color: dxpToken.colorTextNeutral }}
                        breakpoint="Mobile"
                        size="TitleT23Bold"
                      >
                        {GCPI18n({ id: 'lb_point_order_no_data' })}
                      </Text>
                      <Text
                        style={{ color: dxpToken.colorTextNeutral }}
                        breakpoint="Mobile"
                        size="ContentC14Regular"
                      >
                        {GCPI18n({ id: 'lb_point_order_no_data_message' })}
                      </Text>
                    </div>
                  )}
                </>
              )}
            </BaseSpin>
          </InfiniteScroll>
        )}
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  getPointOrderListDXP: payload =>
    dispatch({
      type: 'pointShop/getPointOrderListDXP',
      payload,
    }),
});

export default connect(
  ({ pointShop, loading, index }) => ({
    pointOrderListTotal: pointShop.pointOrderListTotal,
    pointOrderParams: pointShop.pointOrderParams,
    isMulPoints: index.isMulPoints,
    dxpToken: index.dxpToken,
    loading: loading.effects['pointShop/getPointOrderListDXP'] || false,
  }),
  mapDispatchToProps,
)(Order);
